import React from "react";
import "./AxiomTooltip.css";
import ReactTooltip from "react-tooltip";
import Popover from "react-bootstrap/lib/Popover";
import OverlayTrigger from "react-bootstrap/lib/OverlayTrigger";

export default class AxiomTooltip extends React.Component {
  render() {
    return (
      <div className="AxiomTooltip">
        {false && this.props.children}
        <ReactTooltip {...this.props}>{this.props.children}</ReactTooltip>
      </div>
    );
  }
}

export class AxiomTooltipNew extends React.Component {
  render() {
    const { tooltip, place, className, onCellClick, ...rest } = this.props;
    const popover = (
      <Popover id="popover-trigger-hover-focus" {...rest}>
        {tooltip && typeof tooltip === "string" ? <strong>{tooltip}</strong> : tooltip}
      </Popover>
    );

    return tooltip ? (
      <OverlayTrigger trigger={["hover", "focus", "click"]} placement={place} overlay={popover}>
        <div
          className={className ? className : ""}
          style={{ display: "inline-block" }}
          onClick={onCellClick}
        >
          {this.props.children}
        </div>
      </OverlayTrigger>
    ) : (
      <div
        className={className ? className : ""}
        style={{ display: "inline-block" }}
        onClick={onCellClick}
      >
        {this.props.children}
      </div>
    );
  }
}
